import componentConfig from './componentConfig';
import composableConfig from './composableConfig';
import globalConfig from './globalConfig';

export default {
  componentConfig,
  composableConfig,
  globalConfig,
};
